<template>
  <div class="exchange" :class="cssType">
    <div class="exchange-title" :class="locale"></div>
    <div class="exchange-desc">
      <div class="exchange-desc-1">
        {{ $t('poolParty.exchange.desc1') }}
      </div>
      <div class="exchange-desc-2">
        {{ $t('poolParty.exchange.desc2') }}
      </div>
    </div>
    <div class="exchange-main">
      <div class="main-prop-name">{{ $t('poolParty.exchange.mainPropName') }}</div>
      <div class="main-prop-icon">
        <img src="~@/assets/imgs/act/poolParty/exchange-main-prop.png" alt="exchange-main-prop">
      </div>
      <div class="act-prop-list">
        <div class="act-prop-item" v-for="item in globalConf.activityPropConfigList" :key="item.propId">
          <div class="act-prop-item-icon" :class="[item.propId, { got: getActivityPropCount(item.propId) > 0 }]"></div>
          <div class="act-prop-item-name">{{ $t(`poolParty.prop.${item.propId}`) }} * {{ getActivityPropCount(item.propId) }}</div>
        </div>
      </div>
      <PPButton class="btn" v-if="isExchanged" type="gray" disabled>
        {{ $t('poolParty.btnReceived') }}
      </PPButton>
      <PPButton class="btn" v-else-if="canClickExchange" type="green" @click="handleExchange">
        {{ $t('poolParty.btnCanReceive') }}
      </PPButton>
      <PPButton class="btn" v-else type="gray">
        {{ $t('poolParty.btnNotReach') }}
      </PPButton>
    </div>

    <Dialog v-model="dialogVisible" :title="$t('accum.rewardsAllDialog.title')" size="large">
      <div class="dialog-content">
        <div class="prop-icon">
          <img src="~@/assets/imgs/act/poolParty/exchange-main-prop.png" alt="exchange-main-prop">
        </div>
        <div class="prop-name">
          {{ $t(`poolParty.prop.${globalConf.exchangeRewardGameProps[0].propId}`) }} * {{ globalConf.exchangeRewardGameProps[0].count }}
        </div>
      </div>
    </Dialog>
    <!-- <h3>我的活动道具</h3>
    <ul>
      <li v-for="item in globalConf.activityPropConfigList" :key="item.propId">
        {{ item.propName }} x{{ getActivityPropCount(item.propId) }}
      </li>
    </ul>

    <h3>可兑换游戏道具</h3>
    <p>
      {{ globalConf.exchangeRewardGameProps }}
    </p>
    <ul>
      <li v-for="item in globalConf.exchangeRewardGameProps" :key="item.propId">
        {{ item.propName }} x{{ item.count }}
      </li>
    </ul>

    <p>状态：{{ statusText }}</p>
    <button :disabled="!canClickExchange" @click="handleExchange">
      {{ buttonText }}
    </button> -->
  </div>
</template>

<script setup>
/* eslint-disable */
import { computed, inject, ref } from 'vue'
import PoolPartyActApi from '@/config/poolPartyActApi'
import { toastService } from '@/utils/toastService'
import { useI18n } from 'vue-i18n'
import { isMobile } from '@/utils'
import PPButton from '../PPButton/index.vue'
import Dialog from '@/components/Dialog/ActPoolParty/index.vue'
import { useLog } from '@/composables/useLog'
const log = useLog()

const { locale } = useI18n()
const globalConf = inject('globalConf')
const refreshUserDetail = inject('refreshUserDetail')
const cssType = isMobile ? 'mobile' : 'pc'
const getActivityPropCount = (propId) => {
  return globalConf.value.activityPropList.find((item) => item.propId === propId)?.count ?? 0
}

const canClickExchange = computed(() => {
  return globalConf.value.canExchange && !globalConf.value.isExchanged
})
const isExchanged = computed(() => {
  return globalConf.value.isExchanged
})

const dialogVisible = ref(false)
const handleExchange = async () => {
  if (globalConf.value.isExchanged) {
    toastService.show('您已兑换过奖励')
    return
  }
  if (!globalConf.value.canExchange) {
    toastService.show('活动道具未集齐，无法兑换')
    return
  }
  await PoolPartyActApi.exchangeReward()
  try {
    log.track('act_pp_exchange_reward')
  } catch(error) {
    console.error(error)
  }
  dialogVisible.value = true

  await refreshUserDetail()
}
</script>

<style lang="less" scoped src="./pc_style.less"></style>
<style lang="less" scoped src="./mobile_style.less"></style>
